import React, { useEffect, useState } from "react";
import { PerformanceServices } from "./PerformanceServices";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Pagination,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactDatePicker from "react-datepicker";
import _ from "lodash";import ResourcesGraphCluster from "./ResourcesGraphCluster";
import HvResourceCluster from "./HvResourceCluster";
import MetriCard from "../pharos/components/MetriCard";
import styles from "../pharos/DeliveryDashboard.module.css";
import AvailableResourceCluster from "./AvailableResourceCluster";
import DynamicTableOccupation from "./DynamicTableOccupation";
import OccupationHistogram from "./OccupationHistogram";

const InitialState = {
  IdCluster: "0",
  Idrol: "0",
  position: "",
  IdUser: "",
  start_date: null,
  end_date: null,
};

const DashboardResourceCluster = ({
  IdCluster,
  ClusterParams,
  usersCluster,
  projectByCluster,
}) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const from_date = new Date(year, month, 1);
  const to_date = new Date(year, month + 1, 0);
  const [filter, setFilter] = useState({
    ...InitialState,
    IdCluster: IdCluster,
    start_date: from_date,
    end_date: to_date,
  });
  const [t, i18n] = useTranslation("productivity");
  const [users, setUsers] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dataFilter, setDataFilter] = useState([]);
  const [loading, setLoading] = useState(false);  //pagination

  const [filteredUsers, setFilteredUsers] = useState(users);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterApply, setFilterApply] = useState([]);
  const [key, setKey] = useState("summary");
  const [cluster, setCluster] = useState([]);
  const [availableHours, setAvailableHours] = useState([]);
  const [hasfilterDate, setHasFilterDate] = useState("");

  const resourcesPerPage = 1;

  // Actualizar usuarios filtrados

  const loadDataByFilter = async (data) => {
    const controller = new AbortController();
    try {
      setLoading(true);
      const result = await PerformanceServices.getDataClusterByFilter(data);
      console.log(result);
      if (result) {
        setDataFilter(result.task);
        const resultFilter = users
          .map((user) => {
            const userTask = result.task.filter(
              (task) => task.IdUsuario == user.IdUsuario
            );
            return {
              ...user,
              task: userTask,
            };
          })
          .filter((us) => us.task.length > 0);

        setHasFilterDate(result.filterApp);
        setFilteredUsers(resultFilter);
        setFilterApply([result.filterApp]);
        setAvailableHours(result.availableHours);
        setCurrentPage(1);
      }
    } catch (error) {
      Swal.fire("Error", error, "error");
    } finally {
      setLoading(false);
    }

    return () => {
      controller.abort();
    };
  };

  const onLoadPagefilter = async (data) => {
    try {
      const result_user =
        await PerformanceServices.getUserByOrganizationCluster(IdCluster);
      if (result_user) {
        const result = await PerformanceServices.getDataClusterByFilter(data);
        if (result) {
          setDataFilter(result.task);
          const resultFilter = result_user
            ?.map((user) => {
              const userTask = result.task.filter(
                (task) => task.IdUsuario == user.IdUsuario
              );
              return {
                ...user,
                task: userTask,
              };
            })
            .filter((us) => us.task.length > 0);

          setHasFilterDate(result.filterApp);
          setFilteredUsers(resultFilter);
          setFilterApply([result.filterApp]);
          setAvailableHours(result.availableHours);
          setCurrentPage(1);
        }
      }
    } catch (error) {
      Swal.fire("Error", error, "error");
    }
  };

  const handleFilter2 = (e) => {
    e.preventDefault();
    const matchObject = _.isEqual(filter, InitialState);
    if (!matchObject) {
      loadDataByFilter(filter);
    }
  };

  // Calcular paginación
  const totalPages = Math.ceil(filteredUsers.length / resourcesPerPage);
  const indexOfLastResource = currentPage * resourcesPerPage;
  const indexOfFirstResource = indexOfLastResource - resourcesPerPage;
  const currentResource = filteredUsers.slice(
    indexOfFirstResource,
    indexOfLastResource
  )[0];

  // Manejar cambio de página
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  //fin pagination

  const getUser = async () => {
    try {
      const result = await PerformanceServices.getUserByOrganizationCluster(
        IdCluster
      );
      setUsers(result);
    } catch (error) {
      Swal.fire("Error", error, "error");
    }
  };

  const getCluster = async () => {
    try {
      const result = await PerformanceServices.getCluster();
      let cluster = _.filter(result, { DDL: "Cluster" });
      setCluster(cluster);
    } catch (error) {
      Swal.fire("Error", error, "error");
    }
  };

  const handleResetFilter = () => {
    setFilter(InitialState);
    setStartDate(null);
    setEndDate(null);
    setFilteredUsers([]);
  };


  const usersFilters = users.filter((us) => {
    const matchRol = filter.Idrol == "0" || us.IdRol == filter.Idrol;
    const matchPosition =
      filter.position === "" || us.ProfesionCargo === filter.position;
    const matchUser = filter.IdUser === "" || us.IdUsuario === filter.IdUser;
    return matchRol && matchPosition && matchUser;
  });

  const searchRol = (idRol) => {
    return users.filter((us) => us.IdRol == idRol)[0]?.Rol;
  };
  const searchName = (idUser) => {
    return users.filter((us) => us.IdUsuario == idUser)[0]?.Nombre;
  };

  const formaDate = (date) => {
    const dat = date.split("T")[0].split("-");
    return `${dat[2]}-${dat[1]}-${dat[0]}`;
  };

  const searchCluster = (IdCluster) => {
    return cluster.filter((clu) => clu.ID == Number(IdCluster))[0]?.VALOR
      ? cluster.filter((clu) => clu.ID == Number(IdCluster))[0]?.VALOR
      : "0";
  };

  const showFilters = (fil) => {
    if (fil.length > 0) {
      const cluster =
        fil[0].IdCluster != "0"
          ? `Cluster: ${searchCluster(fil[0].IdCluster)}`
          : " ";
      const rol = fil[0].IdRol != "0" ? `Rol: ${searchRol(fil[0].IdRol)}` : "";
      const pos = fil[0].position ? `Cargo: ${fil[0].position}` : "";
      const name = fil[0].IdUser ? `Recurso: ${searchName(fil[0].IdUser)}` : "";
      const start = fil[0].start ? `Desde: ${formaDate(fil[0].start)}` : "";
      const end = fil[0].end ? `Hasta:  ${formaDate(fil[0].end)}` : "";
      const icon = <i className="fa fa fa-arrow-right text-info" />;
      return (
        <div className="small">
          <b>Filtros aplicados :</b>
          {cluster != "" ? <>{cluster}</> : ""}
          {rol != "" ? (
            <>
              {" "}
              {icon}
              {rol}{" "}
            </>
          ) : (
            ""
          )}{" "}
          {pos ? (
            <>
              {" "}
              {icon}
              {pos}{" "}
            </>
          ) : (
            ""
          )}{" "}
          {name ? (
            <>
              {icon} {name}
            </>
          ) : (
            ""
          )}{" "}
          {start ? (
            <>
              {icon} {start}
            </>
          ) : (
            ""
          )}{" "}
          {end ? (
            <>
              {icon} {end}
            </>
          ) : (
            ""
          )}
        </div>
      );
    } else {
      return "";
    }
  };

  useEffect(() => {
    getUser();
    getCluster();
  }, []);

  useEffect(() => {
    onLoadPagefilter(filter);
  }, []);

  const formtUser = (resources) => {
    return resources?.map((re) => {
      return {
        id: re.IdUsuario,
        text: re.Nombre,
      };
    });
  };

  return (
    <>
      <Container
        className="shadow p-3"
        style={{ maxWidth: "1400px", minHeight: "200px" }}
      >
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="summary" title="Resumen Disponibilidad">
            <AvailableResourceCluster
              resources={formtUser(users)}
              IdCluster={IdCluster}
              setKey={setKey}
              loadDataByFilter={loadDataByFilter}
              filterApply={filterApply}
            />
          </Tab>
          <Tab eventKey="resources" title="Recursos">
            <div>
              <Card>
                <Card.Body>
                  <Card.Title>
                    Resumen de participación de recursos por proyecto
                  </Card.Title>
                  Cantidad de usuarios activos :{" "}
                  {users?.filter((us) => us.Estado == "Activo").length}
                </Card.Body>
              </Card>
            </div>

            <Form onSubmit={handleFilter2}>
              <Card className="my-2 py-3 ">
                <div className="d-flex">
                  <Col md={4}>
                    <h6>Recurso:</h6>
                    <Form.Control
                      size="md"
                      as="select"
                      value={filter.IdUser}
                      //disabled={!filter.position}
                      onChange={(e) => {
                        setFilter((prev) => ({
                          ...prev,
                          IdUser: e.target.value !== "0" ? e.target.value : "",
                        }));
                      }}
                    >
                      <option value="0">Recursos...</option>

                      {usersFilters?.map((user, idx) => {
                        return (
                          <option key={idx} value={user.IdUsuario}>
                            {user.Nombre}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </Col>
                  {/*                 <Col md={3} className="">
                    <h6>Cluster:</h6>
                    <Form.Control
                      size="sm"
                      as="select"
                      required
                      value={filter.IdCluster}
                      onChange={(e) => {
                        setFilter((prev) => {
                          return {
                            ...prev,
                            IdCluster:
                              e.target.value != 0
                                ? Number(e.target.value)
                                : "0",
                          };
                        });
                      }}
                    >
                      <option value="0">Cluster...</option>
                      {cluster?.map((clu, idx) => {
                        return (
                          <option key={idx} value={clu.ID}>
                            {clu.VALOR}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </Col>
                  <Col md={3} className="">
                    <h6>Rol:</h6>
                    <Form.Control
                      size="sm"
                      as="select"
                      required
                      value={filter.Idrol}
                      onChange={(e) => {
                        setFilter((prev) => {
                          return {
                            ...prev,
                            Idrol:
                              e.target.value != 0
                                ? Number(e.target.value)
                                : "0",
                          };
                        });
                      }}
                    >
                      <option value="0">Rol...</option>
                      {_.uniqBy(usersFilters, "Rol").map((user, idx) => {
                        return (
                          <option key={idx} value={user.IdRol}>
                            {user.Rol}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </Col> */}
                  {/*  _.uniqBy(users, "Rol")? */}
                  {/*                   <Col md={3}>
                    <h6>Cargo:</h6>
                    <Form.Control
                      size="sm"
                      as="select"
                      value={filter.position}
                      //disabled={filter.Idrol == "0" ? true : false}
                      onChange={(e) => {
                        setFilter((prev) => {
                          return {
                            ...prev,
                            position: e.target.value != 0 ? e.target.value : "",
                          };
                        });
                      }}
                    >
                      <option value="0">Cargo...</option>

                      {_.uniqBy(usersFilters, "ProfesionCargo").map(
                        (user, idx) => {
                          return (
                            <option key={idx} value={user.ProfesionCargo}>
                              {user.ProfesionCargo}
                            </option>
                          );
                        }
                      )}
                    </Form.Control>
                  </Col> */}
                  {/*    _.filter(_.uniqBy(users, "ProfesionCargo"), {
                    IdRol: filter.Idrol,
                  }) */}
                  {/*                   <Col md={3}>
                    <h6>Recurso:</h6>
                    <Form.Control
                      size="sm"
                      as="select"
                      value={filter.IdUser}
                      //disabled={!filter.position}
                      onChange={(e) => {
                        setFilter((prev) => ({
                          ...prev,
                          IdUser: e.target.value !== "0" ? e.target.value : "",
                        }));
                      }}
                    >
                      <option value="0">Recursos...</option>

                      {usersFilters?.map((user, idx) => {
                        return (
                          <option key={idx} value={user.IdUsuario}>
                            {user.Nombre}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </Col> */}
                </div>
                {/*  _.filter(users, {
                    IdRol: filter.Idrol, ProfesionCargo: filter.position}) */}
                <h6 className="h6 mx-3 my-3">
                  {t("productivity_resources_searchdate_title")}
                </h6>{" "}
                <div className="d-flex align-items-center">
                  <Col md={8} className="d-flex">
                    <Col md={6} className="pl-0">
                      <ReactDatePicker
                        style={{ height: "32px" }}
                        selected={startDate}
                        dateFormat="dd/MM/yyyy"
                        filterDate={(date) =>
                          date.getDay() !== 6 && date.getDay() !== 0
                        }
                        wrapperClassName="w-100"
                        className="form-control"
                        locale={
                          window.localStorage.getItem("idioma") === "es"
                            ? "es"
                            : "en"
                        }
                        todayButton={
                          window.localStorage.getItem("idioma") === "es"
                            ? "Hoy"
                            : "Today"
                        }
                        required={endDate ? true : false}
                        /*   disabled={filter.Idrol == "0" ? true : false} */
                        placeholderText={t(
                          "productivity_resources_searchdate_from"
                        )}
                        name="startDate"
                        fixedHeight={false}
                        onChange={(date) => {
                          setStartDate(date);
                          console.log(date);

                          setFilter((prev) => {
                            return { ...prev, start_date: date };
                          });
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <ReactDatePicker
                        selected={endDate}
                        dateFormat="dd/MM/yyyy"
                        filterDate={(date) =>
                          date.getDay() !== 6 && date.getDay() !== 0
                        }
                        wrapperClassName="w-100"
                        className="form-control"
                        style={{ height: "32px" }}
                        placeholderText={t(
                          "productivity_resources_searchdate_to"
                        )}
                        name="endDate"
                        fixedHeight={false}
                        today
                        required={startDate ? true : false}
                        /* disabled={filter.Idrol == "0" ? true : false} */
                        minDate={startDate}
                        locale={
                          window.localStorage.getItem("idioma") === "es"
                            ? "es"
                            : "en"
                        }
                        todayButton={
                          window.localStorage.getItem("idioma") === "es"
                            ? "Hoy"
                            : "Today"
                        }
                        //locale = "es"
                        onChange={(date) => {
                          setEndDate(date);
                          /*  const dataFormt = date.toISOString().split("T")[0]; */
                          setFilter((prev) => {
                            return { ...prev, end_date: date };
                          });
                        }}
                      />
                    </Col>
                  </Col>
                  <Col md={3}>
                    <Button
                      variant="outline-primary"
                      className="mr-2"
                      type="submit"
                      size="sm"
                    >
                      <i className="fa far fa-search" />
                    </Button>
                    <Button
                      onClick={handleResetFilter}
                      variant="outline-info"
                      size="sm"
                    >
                      <i className="fa far fa-undo" />
                    </Button>
                  </Col>
                </div>
              </Card>
            </Form>

            <div>
              <Col className="p-0">
                {loading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner animation="border" variant="info" role="status" />
                  </div>
                ) : (
                  <Card className="p-4">
                    {currentResource ? (
                      <>
                        {" "}
                        <h5>{showFilters(filterApply)}</h5>
                        <h6>
                          Se han encontrado {filteredUsers?.length}{" "}
                          coincidencias con sus filtros...{" "}
                        </h6>
                        <HvResourceCluster
                          user={currentResource}
                          dataFilter={dataFilter}
                          availableHours={availableHours}
                          hasfilterDate={hasfilterDate}
                          formaDate={formaDate}
                        />
                      </>
                    ) : (
                      <>
                        No hay recursos disponibles con los filtros
                        seleccionados.
                      </>
                    )}
                  </Card>
                )}
                {/* Paginación */}
                {totalPages > 1 && (
                  <Pagination
                    style={{ overflow: "auto" }}
                    className="justify-content-center mt-3"
                  >
                    <Pagination.First
                      onClick={() => handlePageChange(1)}
                      disabled={currentPage === 1}
                    />
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    {Array.from({ length: totalPages }, (_, idx) => (
                      <Pagination.Item
                        key={idx + 1}
                        active={currentPage === idx + 1}
                        activeLabel=""
                        onClick={() => handlePageChange(idx + 1)}
                      >
                        {idx + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                )}
              </Col>
            </div>
          </Tab>
          <Tab eventKey="clusterInfo" title="Información Cluster">
            <div className="my-4 d-flex">
              <Col md={4}>
                <MetriCard
                  /* icon={<img src={Workers} />} */
                  value={usersCluster}
                  /* value={capacityProjects?.CapacidadInstalada} */
                  label="Capacidad Instalada "
                  bgColor={"#E88D14"}
                  textColor="#fff"
                  styles={styles}
                />
              </Col>
              <Col md={4}>
                <MetriCard
                  /* icon={<img src={Workers} />} */
                  value={projectByCluster.length}
                  label="Total Proyectos del Cluster"
                  bgColor={"#E88D14"}
                  textColor="#fff"
                  styles={styles}
                />
              </Col>
              <Col md={4}>
                <MetriCard
                  /* icon={<img src={Workers} />} */
                  value={
                    projectByCluster
                      ? projectByCluster?.filter(
                          (pr) => pr.PctCompletadoProyecto < 100
                        ).length
                      : []
                  }
                  label="Proyectos en Curso del Cluster"
                  bgColor={"#E88D14"}
                  textColor="#fff"
                  styles={styles}
                />
              </Col>
            </div>
            <ResourcesGraphCluster
              users={users}
              projects={projectByCluster ? projectByCluster : []}
              clusters={cluster}
            />
          </Tab>
          <Tab
            eventKey="dynamicTableOccupation"
            title="Tablas dinámicas de ocupación"
          >
            <DynamicTableOccupation IdCluster={IdCluster} />
          </Tab>
          <Tab eventKey="ocupationmonth" title="Histograma de ocupación">
            <OccupationHistogram IdCluster={IdCluster} />
          </Tab>
        </Tabs>
      </Container>
    </>
  );
};

export default DashboardResourceCluster;
